
import { usePathname } from "@/lib/router-compat";
import { cn } from "@/lib/utils";

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
  transitionKey?: string;
}

export function PageTransition({ children, className, transitionKey }: PageTransitionProps) {
  const pathname = usePathname();
  const key = transitionKey ?? pathname;

  return (
    <div
      key={key}
      className={cn(
        "flex-1 min-h-0 flex flex-col",
        "motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-2",
        "motion-safe:duration-200 motion-safe:ease-out",
        className
      )}
    >
      {children}
    </div>
  );
}
